import React from "react";
import NoData from "../../../../../components/noData/noData";

// Reusable DetailCard component
const DetailCard = ({ label, value }) => (
  <div className="grid grid-cols-2">
    <span className="text-sm text-gray-500">{label}</span>
    <span className="text-sm font-semibold text-blue-900">{value || "-"}</span>
  </div>
);

// Skeleton Loader
const DetailSkeleton = () => (
  <div className="grid grid-cols-2 animate-pulse">
    <div className="h-5 bg-gray-300 rounded w-3/4 mb-2" />
    <div className="h-5 bg-gray-200 rounded w-2/3 mb-2" />
  </div>
);

const BasicCard = ({ staff, loading }) => {
  if (loading) {
    return (
      <div className="flex flex-col gap-2 rounded-md h-full">
        {Array.from({ length: 3 }).map((_, idx) => (
          <DetailSkeleton key={idx} />
        ))}
      </div>
    );
  }

  if (!staff) {
    return (
      <p className="text-gray-500 p-4 bg-white rounded-md">
        <NoData
          title="No Result Found"
          message="Please try again with another keywords or maybe use generic term"
          buttonText={null}
        />
      </p>
    );
  }

  const generalInfo = [
    { label: "Vendor Name", value: staff.name },
    { label: "Abbreviation", value: staff.abrv },
    { label: "Tags", value: staff.tags },
    { label: "Address", value: staff?.address }
  ];

  const contactInfo = [
    { label: "Contact No.", value: `${staff.country_code} ${staff.phone}` },
    { label: "Alternate No.", value: `${staff.country_code2} ${staff.phone2}` },
    { label: "Email Address", value: staff.email },
    { label: "Website", value: staff.website },
  ];

  const businessInfo = [
    {
      label: "Registration Date",
      value: new Date(staff.created_at).toLocaleString(),
    },
    { label: "Status", value: staff?.status === 1 ? "Active" : "Inactive" },
    { label: "Total Purchase", value: staff?.total_purchase_amount || "0" },
    { label: "Last Purchase Date", value: staff?.last_purchase_date || "0" },
  ];

  const categoriesInfo = [
    {
      label: "Category",
      value: staff?.categories?.map((cat) => cat.name).join(", ") || "-",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 rounded-md ">
      {/* General Information */}
      <div className="bg-white ">
        <div className="border-b">
          <h2 className="text-lg font-semibold text-blue-900  px-4 py-2">
            General Information
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-2 p-4 ">
          {generalInfo.map((item, idx) => (
            <DetailCard key={idx} label={item.label} value={item.value} />
          ))}
        </div>
      </div>

      {/* Contact Information */}
      <div className="bg-white">
        <div className="border-b">
          <h2 className="text-lg font-semibold text-blue-900  px-4 py-2">
            Contact Information
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-y-2 p-4 ">
          {contactInfo.map((item, idx) => (
            <DetailCard key={idx} label={item.label} value={item.value} />
          ))}
        </div>
      </div>

      {/* Business Information */}
      <div className="bg-white">
        <div className="border-b">
          <h2 className="text-lg font-semibold text-blue-900  px-4 py-2">
            Business Information
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-y-2 p-4 ">
          {businessInfo.map((item, idx) => (
            <DetailCard key={idx} label={item.label} value={item.value} />
          ))}
        </div>
      </div>

      <div className="bg-white ">
        <div className="border-b">
          <h2 className="text-lg font-semibold text-blue-900  px-4 py-2">
            Category Information
          </h2>
        </div>
        <div className="grid grid-cols-1 gap-2 p-4 ">
          {categoriesInfo.map((item, idx) => (
            <DetailCard key={idx} label={item.label} value={item.value} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BasicCard;
